import { colorPrimitives } from './colors.primitives';

export const colorBrands = {
  'primary-100': colorPrimitives['pink-100'],
  'primary-200': colorPrimitives['pink-200'],
  'primary-300': colorPrimitives['pink-300'],
  'primary-400': colorPrimitives['pink-400'],
  'primary-500': colorPrimitives['pink-500'],
  'primary-600': colorPrimitives['pink-600'],
  'primary-700': colorPrimitives['pink-700'],
  'primary-800': colorPrimitives['pink-800'],
  'primary-900': colorPrimitives['pink-900'],
  'primary-1000': colorPrimitives['pink-1000'],

  'neutral-100': colorPrimitives['gray-100'],
  'neutral-200': colorPrimitives['gray-200'],
  'neutral-300': colorPrimitives['gray-300'],
  'neutral-400': colorPrimitives['gray-400'],
  'neutral-500': colorPrimitives['gray-500'],
  'neutral-600': colorPrimitives['gray-600'],
  'neutral-700': colorPrimitives['gray-700'],
  'neutral-800': colorPrimitives['gray-800'],
  'neutral-900': colorPrimitives['gray-900'],
  'neutral-1000': colorPrimitives['gray-1000'],

  'info-100': colorPrimitives['blue-100'],
  'info-200': colorPrimitives['blue-200'],
  'info-300': colorPrimitives['blue-300'],
  'info-400': colorPrimitives['blue-400'],
  'info-500': colorPrimitives['blue-500'],
  'info-600': colorPrimitives['blue-600'],
  'info-700': colorPrimitives['blue-700'],
  'info-800': colorPrimitives['blue-800'],
  'info-900': colorPrimitives['blue-900'],
  'info-1000': colorPrimitives['blue-1000'],

  'success-100': colorPrimitives['green-100'],
  'success-200': colorPrimitives['green-200'],
  'success-300': colorPrimitives['green-300'],
  'success-400': colorPrimitives['green-400'],
  'success-500': colorPrimitives['green-500'],
  'success-600': colorPrimitives['green-600'],
  'success-700': colorPrimitives['green-700'],
  'success-800': colorPrimitives['green-800'],
  'success-900': colorPrimitives['green-900'],
  'success-1000': colorPrimitives['green-1000'],

  'warning-100': colorPrimitives['yellow-100'],
  'warning-200': colorPrimitives['yellow-200'],
  'warning-300': colorPrimitives['yellow-300'],
  'warning-400': colorPrimitives['yellow-400'],
  'warning-500': colorPrimitives['yellow-500'],
  'warning-600': colorPrimitives['yellow-600'],
  'warning-700': colorPrimitives['yellow-700'],
  'warning-800': colorPrimitives['yellow-800'],
  'warning-900': colorPrimitives['yellow-900'],
  'warning-1000': colorPrimitives['yellow-1000'],

  'danger-100': colorPrimitives['red-100'],
  'danger-200': colorPrimitives['red-200'],
  'danger-300': colorPrimitives['red-300'],
  'danger-400': colorPrimitives['red-400'],
  'danger-500': colorPrimitives['red-500'],
  'danger-600': colorPrimitives['red-600'],
  'danger-700': colorPrimitives['red-700'],
  'danger-800': colorPrimitives['red-800'],
  'danger-900': colorPrimitives['red-900'],
  'danger-1000': colorPrimitives['red-1000'],
};
